/**
 * @internal
 */
import { useCallback, useState } from 'react';
import { fullscreenElementSupport, isInFullscreen, openFullscreen, } from '@polestar/component-warehouse-react/helpers/fullscreen';
import useIsomorphicLayoutEffect from '@polestar/component-warehouse-react/hooks/useIsomorphicLayoutEffect';
function useFullscreen(ref) {
    const [isFullscreen, setIsFullscreen] = useState(isInFullscreen);
    const setFullscreen = useCallback(() => {
        if (ref) {
            openFullscreen(ref);
        }
    }, [ref]);
    useIsomorphicLayoutEffect(() => {
        if (!fullscreenElementSupport) {
            return;
        }
        const handleFullscreenChange = () => {
            setIsFullscreen(isInFullscreen);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    });
    return [isFullscreen, setFullscreen];
}
export default useFullscreen;
